"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordExpireSoonPopup = void 0;
const react_1 = __importStar(require("react"));
const react_design_system_1 = require("@hdh-core/react-design-system");
const history_1 = require("history");
const react_intl_1 = require("react-intl");
const PasswordExpireSoonPopup = (_a) => {
    var _b;
    var props = __rest(_a, []);
    const [isOpen, setOpen] = (0, react_1.useState)(true);
    const history = (0, history_1.createBrowserHistory)();
    const { getGlobalState, userSettingPage } = props;
    const LoginContext = (_b = getGlobalState()) === null || _b === void 0 ? void 0 : _b.account;
    const passwordExpireSoonErrorMsg = LoginContext.passwordExpireSoonErrorMsg;
    const intl = (0, react_intl_1.useIntl)();
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_design_system_1.ConfirmDialog, { isOpen: isOpen, setOpen: setOpen, iconType: 'reject', title: intl.formatMessage({ id: 'Password-expires-soon-title' }), message: passwordExpireSoonErrorMsg, leftBtnLabel: intl.formatMessage({ id: 'common.button.btnCancel' }), rightBtnLabel: intl.formatMessage({ id: 'change-password-btn' }), onCancelClick: () => {
                setOpen(false);
            }, onConfirmClick: () => {
                setOpen(false);
                history.push(`${userSettingPage}/ChangePassword`);
            } })));
};
exports.PasswordExpireSoonPopup = PasswordExpireSoonPopup;
exports.default = exports.PasswordExpireSoonPopup;
